import { Component, Input, OnInit } from '@angular/core';

import {
  StatusModel,
  UtilisationStatusType
} from 'src/app/model';

@Component({
  selector: 'app-utilisation-status',
  templateUrl: './utilisation-status.component.html',
  styleUrls: ['./utilisation-status.component.css']
})
export class UtilisationStatusComponent implements OnInit {

  @Input() utilisation: StatusModel;

  @Input() title: string;

  @Input() type: UtilisationStatusType;

  constructor() { }

  ngOnInit(): void { }

}
